import styled from "styled-components";

const textDecorTyps = {
  underline: "underline",
  striked: "line-through",
};

const Text = styled.span`
  ${({ size, theme }) =>
    size && `font-size: ${theme.fontSize?.[size] ?? "inherit"}`};
  text-align: ${(props) => props.textAlign || "inherit"};
  font-weight: ${({ weight = "inherit" }) => weight};
  line-height: ${(props) => props.lineHeight || 1.5};
  ${({ theme, color }) =>
    color && `color: ${theme.colors?.[color] ?? "inherit"}`};
  ${({ textDecor }) =>
    textDecor && `text-decoration: ${textDecorTyps?.[textDecor] ?? "none"}`};
`;

export default Text;
